import Vue from "vue";
import Router from "vue-router";
// import IndexPage from "@/pages/IndexPage/IndexPage";
import OauthPage from "@/pages/OauthPage/OauthPage";
import ChatListPage from "@/pages/ChatListPage/ChatListPage";
import ChatDetailPage from "@/pages/ChatDetailPage/ChatDetailPage";
import AgentSettingPage from "@/pages/AgentSettingPage/AgentSettingPage";
import WechatProgramLoginPage from "@/pages/WechatProgramLoginPage/WechatProgramLoginPage";
import ATagHintPage from "@/pages/ATagHintPage/ATagHintPage";
import SmsLoginPage from "@/pages/SmsLoginPage/SmsLoginPage";
import InputCaptchaPage from "@/pages/InputCaptchaPage/InputCaptchaPage";
import TipsPage from "@/pages/TipsPage/TipsPage.vue";
import ChannelErrorPage from "@/pages/ChannelErrorPage/ChannelErrorPage";
import testPage from "@/pages/testPage/testPage";
import OutsideLoginPage from "@/pages/OutsideLoginPage/OutsideLoginPage";
import DesktopPage from "@/pages/DesktopPage/DesktopPage";
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/TipsPage",
      name: "TipsPage",
      component: TipsPage,
      meta: {
        title: "提示",
      },
    },
    {
      path: "/ChannelErrorPage",
      name: "ChannelErrorPage",
      component: ChannelErrorPage,
      meta: {
        title: "提示",
      },
    },
    {
      path: "/OauthPage",
      name: "OauthPage",
      component: OauthPage,
      meta: {
        title: "对话",
      },
    },
    {
      path: "/SmsLoginPage",
      name: "SmsLoginPage",
      component: SmsLoginPage,
      meta: {
        title: "",
      },
    },
    {
      path: "/InputCaptchaPage",
      name: "InputCaptchaPage",
      component: InputCaptchaPage,
      meta: {
        title: "",
      },
    },
    {
      path: "/ChatListPage",
      name: "ChatListPage",
      component: ChatListPage,
      meta: {
        title: "对话",
      },
    },
    {
      path: "/ChatDetailPage",
      name: "ChatDetailPage",
      component: ChatDetailPage,
      meta: {
        title: "对话",
      },
    },
    {
      path: "/AgentSettingPage",
      name: "AgentSettingPage",
      component: AgentSettingPage,
      meta: {
        title: "设置",
      },
    },
    {
      path: "/WechatProgramLoginPage",
      name: "WechatProgramLoginPage",
      component: WechatProgramLoginPage,
      meta: {
        title: "",
      },
    },
    {
      path: "/OutsideLoginPage",
      name: "OutsideLoginPage",
      component: OutsideLoginPage,
      meta: {
        title: "",
      },
    },
    {
      path: "/ATagHintPage",
      name: "ATagHintPage",
      component: ATagHintPage,
      meta: {
        title: "",
      },
    },
    {
      path: "/testPage",
      name: "testPage",
      component: testPage,
      meta: {
        title: "",
      },
    },
    {
      path: "/DesktopPage",
      name: "DesktopPage",
      component: DesktopPage,
      meta: {
        title: "麦绿素",
      },
    },
    {
      path: "*",
      component: DesktopPage,
    },
  ],
});
